/**
 * CollaborationButton Component
 * Button for Live Collaboration with session indicator
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Users } from 'lucide-react';

export const CollaborationButton = ({
  showCollaboration,
  setShowCollaboration,
  collabSessionId,
  setShowSessionManager,
}) => {
  const handleClick = () => {
    if (collabSessionId) {
      // If in a session, toggle the collaboration panel
      setShowCollaboration(!showCollaboration);
    } else {
      // If not in a session, open the session manager
      setShowSessionManager(true);
    }
  };

  return (
    <Button
      variant={showCollaboration ? 'default' : 'ghost'}
      size="sm"
      onClick={handleClick}
      className={`relative p-2 ${showCollaboration ? 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/50' : 'text-zinc-400 hover:text-white hover:bg-emerald-500/20'}`}
      data-testid="collaboration-btn"
      title="Live Collaboration"
    >
      <Users className="w-5 h-5" />
      {collabSessionId && (
        <span className="absolute -top-1 -right-1 w-2 h-2 bg-emerald-400 rounded-full animate-pulse" />
      )}
    </Button>
  );
};

export default CollaborationButton;
